import React, { useState } from 'react';
import { Form, Input, Schema } from 'rsuite';
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import seal from '../../images/LAPELS-LOLA-Logo.png'
import AuthService from "../../services/auth.service"
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';

function ForgotPassword() {
    const push = useNavigate();
    const [state, setState] = useState({
        userId: ""
    })
    const [showAccountRecoverEmail, setShowAccountRecoverEmail] = useState(false);

    const { StringType } = Schema.Types;
    const model = Schema.Model({
        userId: StringType().isRequired('This field is required.'),
    })
    const handleSubmitClick = (validation, event) => {
        AuthService.forgotPassword(state.userId).then(
            (response) => {
                if (response.data.isSuccess === true) {
                    push("/forgotpasswordsuccess");
                } else {
                    Swal.fire("Add failure handler here.")
                }
            }, (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                const toast = Swal.mixin({
                    toast: true,
                    position: 'top',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                toast.fire({
                    icon: 'error',
                    title: resMessage
                })
                setShowAccountRecoverEmail(true);
            }
        )
    }

    const imageStyle = {
        height: '10rem',
        width: '10rem',
        margin: 'auto'
    };
    const centerText = {
        textAlign: 'center'
    }
    const buttonStyle = {
        width: "100%"
    }


    return (
        <div className="loginPage">
            <Card style={{ width: '25rem', paddingTop: '1rem' }}>
                <Card.Img variant="top" src={seal} alt="Lapels Seal" style={imageStyle} />
                <Card.Body>
                    <Card.Title style={centerText}>Forgot your password? Enter User Id to reset your password.</Card.Title>
                    <Form fluid model={model} formValue={state} onChange={state => setState(state)} onSubmit={handleSubmitClick}>
                        <Form.Group>
                            <Form.ControlLabel className='d-none'>
                                User Id
                            </Form.ControlLabel>
                            <Form.Control accepter={Input} placeholder="User Id" name="userId" />
                            <Form.HelpText className='d-none'>User Id is required.</Form.HelpText>
                        </Form.Group>
                        <Button
                            variant="primary"
                            type="submit"
                            style={buttonStyle}>
                            Send
                        </Button>
                    </Form>
                    <br />
                    {showAccountRecoverEmail == true &&
                        <div className="loginFooter centerText">
                            <p><b>Still can't log in?</b> Please email <a href="mailto:AccountRecovery@lapels.com">AccountRecovery@lapels.com</a></p>
                        </div>}
                    <div>
                        <Card.Link as={Link} to="/login">Back to Login</Card.Link>
                    </div>
                </Card.Body>
            </Card>
        </div>
    )
}
export default ForgotPassword;